export const WORKER_SKILLS = [
  "photography",
  "videography",
  "editing",
  "setup",
  "security",
  "driving",
  "bartending",
  "makeup",
  "promotion",
  "construction",
  "dj",
  "social_media",
  "delivery",
  "cleaning",
  "hospitality",
  "tech",
  "general_labor",
  "events",
] as const;

export type WorkerSkill = (typeof WORKER_SKILLS)[number];

export const SKILL_LABEL: Record<WorkerSkill, string> = {
  photography: "📷 Photography",
  videography: "🎥 Video",
  editing: "✂️ Editing",
  setup: "🔧 Setup",
  security: "🛡️ Security",
  driving: "🚗 Driving",
  bartending: "🍹 Bartending",
  makeup: "💄 Makeup",
  promotion: "📣 Promo",
  construction: "🏗️ Construction",
  dj: "🎧 DJ",
  social_media: "📱 Social",
  delivery: "🛵 Delivery",
  cleaning: "🧽 Cleaning",
  hospitality: "🍽️ Hospitality",
  tech: "💻 Tech",
  general_labor: "💪 Labor",
  events: "🎉 Events",
};
